import config from '@app/config';
import { Ads } from './ads';

const { baseImageUrl } = config;

const ads: Ads[] = [
  {
    href: '/catalog/oils/$',
    slot: 'brand',
    banners: [
      {
        name: 'Услуги по замене масла - в подарок',
        erid: 'LjN8KE9wF',
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2817.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2816.jpg`,
        href: '/actions/zamena-masla-v-podarok-1l/?utm_source=site_oil',
        options: {
          heightMobile: 230,
          widthMobile: 576,
          heightDesktop: 100,
          widthDesktop: 1140,
        },
      },
    ],
  },
];

export default ads;
